import Blue from "~/core";
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

new Blue({
	name: 'Proof Points Carousel',
	selector: ".proof-points",
	setup(container) {
		const carousel = container.querySelector(".proof-points__carousel");
	  const wrapper = container.querySelector(".proof-points__wrapper");
		const slides = [...container.querySelectorAll(".proof-points__slide")];
		const prevEl = container.querySelector("button.proof-points__prev");
		const nextEl = container.querySelector("button.proof-points__next");
		const navigation = container.querySelector(".proof-points__navigation");
		const pagination = container.querySelector(".proof-points__pagination");
		const random = Math.ceil(Math.random() * 10000);
		carousel.classList.add("swiper");
		carousel.classList.add("swiper-" + random);
		wrapper.classList.add("swiper-wrapper");
		slides.forEach(slide => slide.classList.add("swiper-slide"));
		pagination.classList.add("swiper-pagination");
		pagination.classList.add("swiper-pagination-" + random);

		if (slides.length < 2) {
			pagination.remove();
			navigation.remove();
			carousel.style.paddingBottom = "0";
		} else {
			const swiper = new Swiper('.swiper-' + random, {
				loop: true,
				navigation: {
					nextEl,
					prevEl
				},
				pagination: {
					el: pagination,
					type: 'custom',
					renderCustom: (swiper, current, total) => {
						return '<span class="swiper-pagination-current">' + current + '</span> <span class="proof-points__of">of</span> <span class="swiper-pagination-total">' + total + '</span>'
					}
				}
			});
		}
	}
});
